import React, { useState, useEffect } from "react";
import { Dialog, Message } from "@jdcfe/legao";
import { addOpportuneInfo } from "utils/api";
import ValidCode, { createdCode } from "./validCode";
// import '@jdcfe/legao/es/Dialog/style/index.css';
// import '@jdcfe/legao/es/Message/style/index.css';
import "./dialog.scss";

let dialog = null;

const DialogContent = () => {
  const [codeList, setCodeList] = useState(createdCode());
  const [loading, setLoading] = useState(false);
  const [username, setUserName] = useState(null);
  const [company, setCompany] = useState(null);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [caigou, setCaigou] = useState(null);
  const [valid, setValid] = useState(null);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    // setUserName(document.querySelector(".username"));
    // setCompany(document.querySelector(".company"));
    // setPhone(document.querySelector(".phone"));
    // setEmail(document.querySelector(".email"));
    // setCaigou(document.querySelector(".caigou"));
  }, []);

  const changeName = (e) => {
    setUserName(e.target.value);
  }
  const changeCompany = (e) => {
    setCompany(e.target.value);
  }
  const changePhone = (e) => {
    setPhone(e.target.value);
  }
  const changeEmail = (e) => {
    setEmail(e.target.value);
  }
  const changeCaigou = (e) => {
    setCaigou(e.target.value);
  }
  const changeValid = (e) => {
    setValid(e.target.value);
  }

  const validForm = () => {

    if (!username) {
      return false;
    }
    if (!company) {
      return false;
    }
    if (!phone || !/^1\d{10}$/.test(phone)) {
      return false;
    }
    // if (
    //   !email ||
    //   !/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
    //     email
    //   )
    // ) {
    //   return false;
    // }
    if (!caigou || caigou.length < 10) {
      // showMessage("请填写您的采购需求,不小于10个字符");
      return false;
    }
    // if (
    //   !valid ||
    //   codeList
    //     .map((item) => item.code)
    //     .join("")
    //     .toLowerCase() !== valid.toLowerCase().trim()
    // ) {
    //   console.log('valid', valid, codeList);
    //   // showMessage("请填写正确的验证码");
    //   return false;
    // }

    return true;
  };

  const onsubmit = () => {
    if (loading) {
      showMessage("请稍后再试～");
      return;
    }
    setSubmit(true)
    if (validForm()) {
      setLoading(true);
      addOpportuneInfo({
        contractName: username.trim(),
        companyName: company.trim(),
        phone: phone.trim(),
        email: 'qycggj@jd.com',
        purchasingDemand: caigou.trim(),
      }).then((res) => {
        setLoading(false);
        if (res.data.success) {
          showMessage("提交成功", "success");
          dialog.close();
        } else {
          showMessage(res.data.resultMessage);
        }
      });
    } else {
      setCodeList(createdCode());
    }
  };

  const handleCodeListUpdate = () => {
    setCodeList(createdCode());
  };

  return (
    <React.Fragment>
    <div className="header-box">
      <h3 className="sub-title">京东VOP业务咨询</h3>
      <p className="sub-content">
      为更及时有效响应您的需求，敬请注意：<br />
      1.请您提供完整真实的企业信息（公司名称）<br />
      2.个人用户和供应商伙伴请勿再次登记，敬请前往 www.jd.com</p>
    </div>
    <div className="dialog-content">
      
      <div className="dialog-form-item">
        <div className="title">姓名</div>
        <input
          type="text"
          className="form-field username"
          placeholder="请输入姓名"
          onChange={changeName}
        />
        {submit && !username && 
          <p className="sub-error">请输入姓名</p>
        }
      </div>
      <div className="dialog-form-item">
        <div className="title">公司名称</div>
        <input
          type="text"
          className="form-field company"
          placeholder="请提供真实企业/公司名称"
          onChange={changeCompany}
        />
        {submit && !company && 
          <p className="sub-error">请提供真实企业/公司名</p>
        }
      </div>
      <div className="dialog-form-item">
        <div className="title">手机号</div>
        <input
          type="text"
          className="form-field phone"
          placeholder="请填写您的手机号"
          maxLength="11"
          onChange={changePhone}
        />
        {submit && (!phone || !/^1\d{10}$/.test(phone)) && 
          <p className="sub-error">请填入正确的手机号码</p>
        }
      </div>
      {/* <div className="dialog-form-item">
        <div className="title">电子邮箱</div>
        <input
          type="text"
          className="form-field email"
          placeholder="请填写您的邮箱"
          onChange={changeEmail}
        />
        {submit && ( 
                  !email || 
                  !/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
                    email
                  )
              ) && 
          <p className="sub-error">请填入正确的电子邮箱</p>
        }
      </div> */}
      <div className="dialog-form-item">
        <div className="title">采购需求</div>
        <textarea
          className="form-field-area caigou"
          placeholder="请填写10-200字的详细采购需求"
          maxLength="200"
          onChange={changeCaigou}
        />
        {submit && (!caigou || caigou.length < 10)&& 
          <p className="sub-error">请填写您的采购需求，不小于10个字符</p>
        }
      </div>
      {/* <div className="dialog-form-yanzheng">
        <div className="title">验证码</div>
        <input
          type="text"
          className="form-field-yanzheng valid"
          placeholder="请填写验证码"
          maxLength="4"
          onChange={changeValid}
        />
        {submit && (!valid ||
                    codeList
                      .map((item) => item.code)
                      .join("")
                      .toLowerCase() !== valid.toLowerCase().trim()) &&
          <p className="sub-error">请填写正确的验证码</p> 
        }
        <div className="form-valid-wrapper">
          <ValidCode
            codeList={codeList}
            onCodeListUpdate={handleCodeListUpdate}
          ></ValidCode>
        </div>
      </div> */}
      <div className="dialog-form-item">
        <div className="title"></div>
        <div className="dialog-form-submit">
          <a
            href=""
            onClick={(e) => {
              e.preventDefault();
              onsubmit();
            }}
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|7"
          >
            {loading ? "提交中，请稍后..." : "提交"}
          </a>
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

const showMessage = (tip, type = "wrong") => {
  Message.showMsg({
    type,
    description: tip,
    autohide: true,
    closable: false,
    showIcon: true,
  });
};

export function showDialog() {
  console.log('点击 dialog')
  dialog = Dialog.confirm({
    // title: "我要合作",
    children: <DialogContent />,
    wrapStyle: {
      zIndex: 99,
    },
    hasClose: true,
    footer: false,
    isOpen: true,
    className: "vop-index-dialog-wrapper1",
    onClose: () => {
      dialog.close();
    },
  });
}
